export class EmployeeDetails {
    id: string;
    firstName: string;
    lastName: string;
}


// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/employees/details/employee-details.model.ts